import { cr } from "fire-wind-water";
import Radio from "ant-design-vue/lib/radio"; // 加载 JS
import "ant-design-vue/lib/radio/style/css"; // 加载 CSS
import Vue from "vue";
import common from "./common";
Vue.use(Radio);
const radioMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      fieldObj: {},
      optionId: [] //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请选择";
    }
    this.fieldObj = new window.$sk.Radio(this.field);
    cr.each(this.fieldObj.listOptions, m => {
      if (m.isDefault == 1) {
        this.optionId = m.optionId;
        this.fieldObj.setValue(m.optionId);
      }
    });
    //回填数据
    if (!this.fieldValue) {
      return;
    }
    cr.each(this.fieldObj.listOptions, b => {
      if (b.optionValue == this.fieldValue) {
        this.optionId = b.optionId;
        this.fieldObj.setValue(b.optionId);
      }
    });
  },
  methods: {
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
    },
    onChange(e) {
      this.optionId = e.target.value;
      this.fieldObj.setValue(e.target.value);
      let value ="";
      //针对客户管理里面的独立选项 fieldLevel 1是全局 2是模块 4 自定义的
      if((this.field.fieldLevel==1||this.field.fieldLevel==2||this.field.fieldLevel==3)&&this.field.listOptionType=='CUSTOM'){
        this.fieldObj.listOptions.filter(b => {
          if(b.checked){
            value =b.optionValue;
          }
        });
      }
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value:value?value:e.target.value,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    }
  }
};
export default radioMixin;
